export const SET_API_STATUS = 'SET_API_STATUS'
export const SET_API_ERROR  = 'SET_API_ERROR'

export const SET_COLOR   = 'SET_COLOR'
export const SET_PRODUCT = 'SET_PRODUCT'

export const FETCH_CART       = 'FETCH_CART'
export const ADD_TO_CART      = 'ADD_TO_CART'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'

export const SET_SHIPPING_ADDRESS   = 'SET_SHIPPING_ADDRESS'
export const SET_SHIPPING_METHOD    = 'SET_SHIPPING_METHOD'
export const CLEAR_SHIPPING_METHOD  = 'CLEAR_SHIPPING_METHOD'
export const FETCH_SHIPPING_METHODS = 'FETCH_SHIPPING_METHODS'

export const FETCH_PAYMENT_AUTHORIZATION = 'FETCH_PAYMENT_AUTHORIZATION'
export const SET_PAYMENT_AUTHORIZATION = 'SET_PAYMENT_AUTHORIZATION'

export const PLACE_ORDER  = 'PLACE_ORDER'
export const CANCEL_ORDER = 'CANCEL_ORDER'


// WEBPACK FOOTER //
// ./src/store/types.js